module.exports = __webpack_public_path__ + "static/media/covi_ppe_ffp_mas.f064512e.png";